import AsyncStorage from "@react-native-async-storage/async-storage";
import { Image, Linking, Platform } from "react-native";
import { EventRegister } from "react-native-event-listeners";
import RNFS from 'react-native-fs';
import FirebaseService from './FirebaseService';
import colors from "../resources/colors";
import { format } from "date-fns";

const DataController = {
  colourNameToHex(colour) {
    var colours = {
      aliceblue: '#f0f8ff',
      antiquewhite: '#faebd7',
      aqua: '#00ffff',
      aquamarine: '#7fffd4',
      azure: '#f0ffff',
      beige: '#f5f5dc',
      bisque: '#ffe4c4',
      black: '#000000',
      blanchedalmond: '#ffebcd',
      blue: '#0000ff',
      blueviolet: '#8a2be2',
      brown: '#a52a2a',
      burlywood: '#deb887',
      cadetblue: '#5f9ea0',
      chartreuse: '#7fff00',
      chocolate: '#d2691e',
      coral: '#ff7f50',
      cornflowerblue: '#6495ed',
      cornsilk: '#fff8dc',
      crimson: '#dc143c',
      cyan: '#00ffff',
      darkblue: '#00008b',
      darkcyan: '#008b8b',
      darkgoldenrod: '#b8860b',
      darkgray: '#a9a9a9',
      darkgreen: '#006400',
      darkkhaki: '#bdb76b',
      darkmagenta: '#8b008b',
      darkolivegreen: '#556b2f',
      darkorange: '#ff8c00',
      darkorchid: '#9932cc',
      darkred: '#8b0000',
      darksalmon: '#e9967a',
      darkseagreen: '#8fbc8f',
      darkslateblue: '#483d8b',
      darkslategray: '#2f4f4f',
      darkturquoise: '#00ced1',
      darkviolet: '#9400d3',
      deeppink: '#ff1493',
      deepskyblue: '#00bfff',
      dimgray: '#696969',
      dodgerblue: '#1e90ff',
      firebrick: '#b22222',
      floralwhite: '#fffaf0',
      forestgreen: '#228b22',
      fuchsia: '#ff00ff',
      gainsboro: '#dcdcdc',
      ghostwhite: '#f8f8ff',
      gold: '#ffd700',
      goldenrod: '#daa520',
      gray: '#808080',
      green: '#008000',
      greenyellow: '#adff2f',
      honeydew: '#f0fff0',
      hotpink: '#ff69b4',
      'indianred ': '#cd5c5c',
      indigo: '#4b0082',
      ivory: '#fffff0',
      khaki: '#f0e68c',
      lavender: '#e6e6fa',
      lavenderblush: '#fff0f5',
      lawngreen: '#7cfc00',
      lemonchiffon: '#fffacd',
      lightblue: '#add8e6',
      lightcoral: '#f08080',
      lightcyan: '#e0ffff',
      lightgoldenrodyellow: '#fafad2',
      lightgrey: '#d3d3d3',
      lightgreen: '#90ee90',
      lightpink: '#ffb6c1',
      lightsalmon: '#ffa07a',
      lightseagreen: '#20b2aa',
      lightskyblue: '#87cefa',
      lightslategray: '#778899',
      lightsteelblue: '#b0c4de',
      lightyellow: '#ffffe0',
      lime: '#00ff00',
      limegreen: '#32cd32',
      linen: '#faf0e6',
      magenta: '#ff00ff',
      maroon: '#800000',
      mediumaquamarine: '#66cdaa',
      mediumblue: '#0000cd',
      mediumorchid: '#ba55d3',
      mediumpurple: '#9370d8',
      mediumseagreen: '#3cb371',
      mediumslateblue: '#7b68ee',
      mediumspringgreen: '#00fa9a',
      mediumturquoise: '#48d1cc',
      mediumvioletred: '#c71585',
      midnightblue: '#191970',
      mintcream: '#f5fffa',
      mistyrose: '#ffe4e1',
      moccasin: '#ffe4b5',
      navajowhite: '#ffdead',
      navy: '#000080',
      oldlace: '#fdf5e6',
      olive: '#808000',
      olivedrab: '#6b8e23',
      orange: '#ffa500',
      orangered: '#ff4500',
      orchid: '#da70d6',
      palegoldenrod: '#eee8aa',
      palegreen: '#98fb98',
      paleturquoise: '#afeeee',
      palevioletred: '#d87093',
      papayawhip: '#ffefd5',
      peachpuff: '#ffdab9',
      peru: '#cd853f',
      pink: '#ffc0cb',
      plum: '#dda0dd',
      powderblue: '#b0e0e6',
      purple: '#800080',
      rebeccapurple: '#663399',
      red: '#ff0000',
      rosybrown: '#bc8f8f',
      royalblue: '#4169e1',
      saddlebrown: '#8b4513',
      salmon: '#fa8072',
      sandybrown: '#f4a460',
      seagreen: '#2e8b57',
      seashell: '#fff5ee',
      sienna: '#a0522d',
      silver: '#c0c0c0',
      skyblue: '#87ceeb',
      slateblue: '#6a5acd',
      slategray: '#708090',
      snow: '#fffafa',
      springgreen: '#00ff7f',
      steelblue: '#4682b4',
      tan: '#d2b48c',
      teal: '#008080',
      thistle: '#d8bfd8',
      tomato: '#ff6347',
      turquoise: '#40e0d0',
      violet: '#ee82ee',
      wheat: '#f5deb3',
      white: '#ffffff',
      whitesmoke: '#f5f5f5',
      yellow: '#ffff00',
      yellowgreen: '#9acd32',
    };

    if (typeof colours[colour?.toLowerCase()] !== 'undefined') {
      return colours[colour.toLowerCase()];
    }

    return false;
  },

  getTextColor(hexCode) {
    const hexColor = hexCode.replace('#', '');

    const red = parseInt(hexColor.substr(0, 2), 16);
    const green = parseInt(hexColor.substr(2, 2), 16);
    const blue = parseInt(hexColor.substr(4, 2), 16);

    const contrastYIQ = (red * 299 + green * 587 + blue * 114) / 1000;

    return contrastYIQ >= 128 ? 'black' : 'white';
  },

  async saveRecentlyViewed(id) {
    try {
      let array = [];
      let recently = await AsyncStorage.getItem('recentlyViewed');

      let item = {
        id,
        time: Date.now(),
      };

      if (recently) {
        array = JSON.parse(recently);

        const index = array.findIndex(_item => _item.id === id);
        // console.log('saveRecentlyViewed', index);
        if (index === -1) {
          if (array.length === 10) {
            array.splice(0, 1);
            array.push(item);
          } else {
            array.push(item);
          }
        } else {
          array.splice(index, 1);
          array.push(item);
        }
      } else {
        array = [item];
      }

      await AsyncStorage.setItem('recentlyViewed', JSON.stringify(array));
      EventRegister.emit('recently-viewed/updated')
    } catch (error) {
      console.log(error);

      return false;
    }
  },

  async getRecentlyViewed() {
    try {
      let recently = await AsyncStorage.getItem('recentlyViewed');
      let results = [];

      if (recently) {
        results = JSON.parse(recently);
        // console.log(results);
        results = results.sort((a, b) => b.time - a.time);
        // console.log(results);
      }

      return results;
    } catch (error) {
      console.log('getRecentlyViewed', error);

      return [];
    }
  },

  async addBookmark(id, date) {
    try {
      let array: [];
      const bookmarks = await AsyncStorage.getItem('bookmarks');

      if (bookmarks) {
        array = JSON.parse(bookmarks);

        const index = array.indexOf(id);

        if (index > -1) {
          !__DEV__ && FirebaseService.logEvent('day_bookmark_pressed', { type: 'remove', date });
          array.splice(index, 1);
        } else {
          !__DEV__ && FirebaseService.logEvent('day_bookmark_pressed', { type: 'add', date });
          array.push(id);
        }
      } else {
        !__DEV__ && FirebaseService.logEvent('day_bookmark_pressed', { type: 'add', date });
        array = [id];
      }

      await AsyncStorage.setItem('bookmarks', JSON.stringify(array));
      EventRegister.emit('bookmarks/updated');

      return true;
    } catch (error) {
      console.log(error);

      return false;
    }
  },

  async getBookmarks() {
    try {
      let bookmarks = await AsyncStorage.getItem('bookmarks');

      return bookmarks ? JSON.parse(bookmarks) : [];
    } catch (error) {
      console.log('getBookmarks', error);

      return [];
    }
  },

  async addNote(id, note) {
    try {
      let array: [];
      const notes = await AsyncStorage.getItem('notes');

      // console.log(notes);

      if (notes !== null) {
        array = JSON.parse(notes);

        const index = array.findIndex((_note) => _note.id === id);

        if (index > -1) {
          array.splice(index, 1, { id, note });
        } else {
          array.push({ id, note });
        }
      } else {
        array = [{ id, note }];
      }

      await AsyncStorage.setItem('notes', JSON.stringify(array));
      EventRegister.emit('notes/updated');

      return true;
    } catch (error) {
      console.log(error);

      return false;
    }
  },

  async removeNote(id) {
    try {
      let array: [];
      const notes = await AsyncStorage.getItem('notes');

      if (notes) {
        array = JSON.parse(notes);

        const index = array.findIndex((_note) => _note.id === id);

        if (index > -1) {
          array.splice(index, 1);

          await AsyncStorage.setItem('notes', JSON.stringify(array));

          EventRegister.emit('notes/updated');
        }
      }

      return true;
    } catch (error) {
      console.log(error);

      return false;
    }
  },

  async getAllNotes() {
    try {
      let notes = await AsyncStorage.getItem('notes');

      return notes ? JSON.parse(notes) : [];
    } catch (error) {
      console.log(error);

      return [];
    }
  },

  async getNote(id) {
    try {
      let note;
      let notes: [] = await AsyncStorage.getItem('notes');

      if (notes) {
        notes = JSON.parse(notes);

        note = notes.find((note) => note.id === id);

        return note ? note : null;
      }

      return null;
    } catch (error) {
      console.log(error);

      return null;
    }
  },


  async setFontMultiplier(multiplier) {
    try {
      await AsyncStorage.setItem('fontMultiplier', `${multiplier}`);
      EventRegister.emit('settings/font-size-updated');
    } catch (error) {
      console.log(error);
    }
  },

  async getFontMultiplier() {
    const fontMultiplier = await AsyncStorage.getItem('fontMultiplier');

    if (fontMultiplier != null) {
      return parseFloat(fontMultiplier);
    } else {
      await this.setFontMultiplier(1);
      return 1;
    }

  },

  // Mainly just a helper method for development in case the multiplier value becomes corrupted
  async deleteFontMulitplier() {
    await AsyncStorage.removeItem('fontMultiplier');
  },


  async saveServiceType(index) {
    try {
      await AsyncStorage.setItem('serviceType', `${index}`);
    } catch (error) {
      console.log(error);
    }
  },

  async getServiceType() {
    try {
      const serviceType = await AsyncStorage.getItem('serviceType');

      return serviceType ? parseInt(serviceType, 10) : 0;
    } catch (error) {
      console.log(error);
      return 0;
    }
  },

  async saveCollectType(index) {
    try {
      await AsyncStorage.setItem('collectType', `${index}`);
    } catch (error) {
      console.log(error);
    }
  },

  async getCollectType() {
    try {
      const collectType = await AsyncStorage.getItem('collectType');

      return collectType ? parseInt(collectType, 10) : 0;
    } catch (error) {
      console.log(error);
      return 0;
    }
  },

  async saveCollects(type) {
    try {
      await AsyncStorage.setItem('collectToShow', type);
      EventRegister.emit('setting/collect-type-changed');
    } catch (error) {
      console.log(error);
    }
  },

  async getCollects() {
    try {
      const collectType = await AsyncStorage.getItem('collectToShow');

      return collectType ? collectType : 'Collect 1';
    } catch (error) {
      console.log(error);
      return 'Collect 1';
    }
  },

  async saveAppOpenBehaviour(index) {
    try {
      await AsyncStorage.setItem('appOpenBehaviour', `${index}`);
    } catch (error) {
      console.log(error);
    }
  },

  async getAppOpenBehaviour() {
    try {
      const appOpenBehaviour = await AsyncStorage.getItem('appOpenBehaviour');

      return appOpenBehaviour ? parseInt(appOpenBehaviour, 10) : 0;
    } catch (error) {
      console.log(error);
      return 0;
    }
  },

  indexOfVerseObject(array, object) {
    for (let i = 0; i < array.length; i++) {
      let ref = array[i];

      if (ref.verseRef === object.verseRef) {
        return i;
      }
    }

    return -1;
  },

  async getBibleHTMLFromFile(file, removeHeading) {
    try {
      let uri;
      let html;

      if (Platform.OS === 'web') {
        html = file;
      } else {
        uri = Image.resolveAssetSource(file).uri;

        if (__DEV__) {
          html = await fetch(uri);
          html = await html.text();
        } else if (Platform.OS === 'ios') {
          // Release version - don't decode uri
          html = await RNFS.readFile(uri, 'utf8');
          // Debug version - need to decode uri
          // html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
        } else if (Platform.OS === 'android') {
          html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
          // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
        }
      }

      html = html
        .replace(/<p>\s+<\/p>/gim, '')
        .replace('<p>', '')
        .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
        .replace(/<span class="\w+">\d+<\/span>(?!&nbsp;)/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<br class=kk \/>/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<sup class="\w+">\d+<\/sup>(?!&nbsp;)/gim, function (match, token) {
          return ` ${match} `;
        })
        .replace(/<h2 class="passageref">(.*?)<\/h2>/gm, function (match, token) {
          return match.replace(/\[|\]/gm, '');
        })
        // .replace(/ style="[^\"]*"/gim, '')
        // .replace(/ style='[^\']*'/gim, '')
        .replace(/class=MsoNormal/gim, '')
        .replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ');

      if (removeHeading) {
        html = html.replace(/<h2 class=".+">(.*?)<\/h2>/gm, '');
      }

      return html;
    } catch (error) {
      console.log(error);
      return '';
    }
  },

  async saveHymnsSubscription(subscription) {
    try {
      if (subscription) {
        await AsyncStorage.setItem('hymnsSubscription', JSON.stringify(subscription));
        EventRegister.emit('subscriptions/hymns-updated');
      }
    } catch (error) {
      console.log(error);
    }
  },

  async getHymnsSubscription() {
    try {
      const subscription = await AsyncStorage.getItem('hymnsSubscription');

      EventRegister.emit('subscriptions/hymns-updated');
      return subscription ? JSON.parse(subscription) : null;
    } catch (error) {
      console.log(error);

      return null;
    }
  },

  openLink(url) {
    try {
      if (Platform.OS === 'web') {
        window.open(url, '_blank');
      } else {
        Linking.openURL(url);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async saveChurchInformation(object) {
    try {
      await AsyncStorage.setItem('SWChurchInformation', JSON.stringify(object));
    } catch (error) {
      console.log(error);
    }
  },

  async getChurchInformation() {
    try {
      const info = await AsyncStorage.getItem('SWChurchInformation');

      return info ? JSON.parse(info) : null;
    } catch (error) {
      console.log(error);

      return null;
    }
  },

  formatHTMLToPlaintext(string, type) {
    let plaintext = string;
    plaintext = plaintext.replace(/&nbsp;/gm, ' ');
    plaintext = plaintext.replace(/<\/h2/gm, '\n</h2');
    plaintext = plaintext.replace(/<\/span/gm, ' </span');
    plaintext = plaintext.replace(/<\/sup/gm, ' </sup');
    plaintext = plaintext.replace(/<br>/gm, '\n');
    plaintext = plaintext.replace(/<red>/gm, '');
    plaintext = plaintext.replace(/<\/red>/gm, '');
    plaintext = plaintext.replace(/&#149;/gm, '•');
    plaintext = plaintext.replace(/\n{3,}/gm, '\n');
    plaintext = plaintext.replace(/\n{2,}/gm, '\n');
    plaintext = plaintext.replace(/\s{3,}/gm, '\n    ');
    plaintext = plaintext.replace(/<!--[\s\S]*?-->/gm, '');
    plaintext = plaintext.replace(/&#145;/gm, '‘');
    plaintext = plaintext.replace(/&#146;/gm, '’');
    plaintext = plaintext.replace(/&#147;/gm, '“');
    plaintext = plaintext.replace(/&#148;/gm, '”');
    plaintext = plaintext.replace(/&#151;/gm, '-');
    plaintext = plaintext.replace(/&#8211;/gm, '-');
    plaintext = plaintext.replace(/<span[\s]+([^>]+)>&diams;&#xFE0E;<\/span>/gm, '\n');


    if (type !== 'AdditionalWeekdayLectionary') {
      plaintext = plaintext.replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '');
    }

    plaintext = plaintext.replace(/<[^>]*>?/gm, '');
    plaintext = plaintext.replace(/&diams;&#xFE0E;/gm, '');

    __DEV__ && console.log('formatHTMLToPlaintext: ', plaintext);
    return plaintext;
  },

  async saveCurrentSubscription(subscription) {
    try {
      if (subscription) {
        await AsyncStorage.setItem('subscription', JSON.stringify(subscription));
      }
    } catch (error) {
      console.log(error);
    }
  },

  async getCurrentSubscription() {
    try {
      const subscription = await AsyncStorage.getItem('subscription');

      return subscription ? JSON.parse(subscription) : null;
    } catch (error) {
      console.log(error);

      return null;
    }
  },

  async saveExpiryDate(time) {
    try {
      await AsyncStorage.setItem('expiryDate', time);
    } catch (error) {
      console.log(error);
    }
  },

  async getExpiryDate() {
    try {
      const expiryDate = await AsyncStorage.getItem('expiryDate');

      return expiryDate ? expiryDate : 0;
    } catch (error) {
      console.log(error);
    }
  },

  eventShouldExpand(option) {
    const options = [
      'Lesser Festival',
      'Commemoration',
      'Ember/Rogation',
      'Ember Day',
      'Rogation Day',
    ];

    __DEV__ && console.log('eventShouldExpand', option, options);

    return options.includes(option);
  },

  eventShouldShowOption(option) {
    const options = [
      'Principal Feast',
      'Principal Holy Day',
      'Festival',
      'Lesser Festival',
      'Commemoration',
    ];

    return options.includes(option);
  },

  getDropdownStyle(option) {
    switch (option) {
      case 'Principal Feast':
        return {
          fontFamily: 'FiraSans-SemiBold',
          fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
          color: colors.red,
        };
      case 'Principal Holy Day':
        return {
          fontFamily: 'FiraSans-SemiBold',
          fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
          color: colors.red,
        };
      case 'Festival':
        return {
          fontFamily: 'FiraSans-Regular',
          fontWeight: 'normal',
          fontStyle: 'normal',
          color: colors.red,
        };
      case 'Lesser Festival':
        return {
          fontFamily: 'FiraSans-Regular',
          fontWeight: 'normal',
          fontStyle: 'normal',
        };
      case 'Commemoration':
        return {
          fontFamily: 'FiraSans-Italic',
          fontWeight: 'normal',
          fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
        };
      case 'Black roman':
        return {
          fontFamily: 'FiraSans-Regular',
          fontWeight: 'normal',
          fontStyle: 'normal',
        };
      case 'Black italic':
        return {
          fontFamily: 'FiraSans-Italic',
          fontWeight: 'normal',
          fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
        };
      case 'Ember/Rogation':
        return {
          fontFamily: 'FiraSans-Regular',
          fontWeight: 'normal',
          fontStyle: 'normal',
        };
      default:
        return {
          fontFamily: 'FiraSans-Regular',
          fontWeight: 'normal',
          fontStyle: 'normal',
        };
    }
  },

  formatDate(date: Date) {
    const [year, month, day] = date.toISOString().substring(0, 10).split('-')
    return format(new Date(
      year,
      (month - 1),
      day,
    ), 'yyyy-MM-dd');
  }
};

export default DataController;
